// extracted by mini-css-extract-plugin
export default {"headerContainer":"ProductBrowserPage_headerContainer__ACMAF","contentContainer":"ProductBrowserPage_contentContainer__mJCFA"};